// src/components/common/EmptyState.jsx
import React from 'react'
import Button from './Button.jsx'

export default function EmptyState({ 
  title = "No items found", 
  message = "There are no items to display at the moment.", 
  action,
  actionLabel,
  onAction,
  className = "" 
}) {
  return (
    <div className={`text-center py-12 ${className}`}>
      <svg
        className="mx-auto h-12 w-12 text-gray-400"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1}
          d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <h3 className="mt-2 text-sm font-medium text-gray-900">{title}</h3>
      <p className="mt-1 text-sm text-gray-500">{message}</p>
      {action && onAction && (
        <div className="mt-6">
          <Button onClick={onAction}>
            {actionLabel || action}
          </Button>
        </div>
      )}
    </div>
  )
}